/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=9d8e82c4&scoped=true&"
import script from "./dialog.vue?vue&type=script&lang=ts&"
export * from "./dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8e82c4",
  null
  
)

export default component.exports